import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/anime";

export default function AnimeCard({ anime, rank }: { anime: Anime; rank?: number }) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group relative flex flex-col overflow-hidden rounded-lg border border-background-800 bg-background-900 transition-all duration-300 hover:border-primary-700"
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden">
        <img
          src={anime.cover}
          alt={`${anime.title} 高清全集免费在线观看与下载`}
          title={`${anime.title} 全集资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent" />
        <span className="absolute left-2 top-2 rounded-md bg-background-950/80 px-2 py-0.5 text-xs font-semibold text-primary-400">
          {anime.category}
        </span>
        {rank !== undefined && (
          <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-xs font-black text-background-950">
            {rank}
          </span>
        )}
        <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded-md bg-background-950/80 px-2 py-0.5 text-xs text-foreground-100">
          <i className="ri-play-circle-line text-primary-400" />
          {anime.episodes} 集
        </span>
      </div>
      <div className="flex flex-col gap-1 p-3">
        <h3 className="truncate text-sm font-bold text-foreground-100 transition-colors group-hover:text-primary-400">
          {anime.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-400" />
            {anime.score.toFixed(1)}
          </span>
          <span>{anime.year} 年</span>
        </div>
      </div>
    </Link>
  );
}